import { createStore } from 'vuex'
const store = createStore({
    state: {
        cancelTokenArr: [],
        socket: '',
        treeData: [],
    },
    mutations: {
        pushToken(state, payload) {
            state.cancelTokenArr.push(payload.cancelToken)
        },
        clearToken({ cancelTokenArr }) {
            cancelTokenArr.forEach((item) => {
                item('路由跳转取消请求')
            })
            cancelTokenArr = []
        },
        pushSocketInstance(state, payload) {
            state.socket = payload
        },
        pushTreeData(state, payload) {
            state.treeData = payload
        },
    },

})
export default store